import React from 'react'
import { Box, Stepper, Step, StepLabel, StepContent, Typography, NoSsr } from '@mui/material'

export const TermsCondition = () => {
  const steps = [
    {
      label: 'Step 3',
      description: `Fill in the form and attach a digital copy of your proof of purchase. `,
    },
    {
      label: 'Step 4',
      description: `Submit the completed form. By submitting this form, you confirm that you have read, understood, and will respect the terms and conditions & PDPA.`,
    },
    {
      label: 'Step 5',
      description: `You will receive Touch'N Go reload pin number through SMS within 3 working days if your submission is approved.`,
    },
  ]

  return (
    <Box
      minHeight={350}
      maxWidth={900}
      px={3}
      py={5}
      display='flex'
      justifyContent='center'
      alignContent='center'
      m='auto'
      flexDirection='column'
    >
      <Stepper orientation='vertical'>
        <Step active={true}>
          <StepLabel>Step 1</StepLabel>
          <StepContent>
            <Typography>
              Purchase Min. 2 unit of Nexen Tire from participating dealers during the campaign
              period from 1th Aug 2024 to 30th September 2024.
            </Typography>
          </StepContent>
        </Step>
        <Step active={true}>
          <StepLabel>Step 2</StepLabel>
          <StepContent>
            <Typography>
              Scan the QR code or visit{' '}
              <a href='/nexentireregister'>https://htperformancetyre.com.my/nexentireregister</a> to
              access the entry page.
            </Typography>
          </StepContent>
        </Step>
        {steps.map((step, index) => (
          <Step key={step.label} active={true}>
            <StepLabel
              optional={index === 2 ? <Typography variant='caption'>Last step</Typography> : null}
            >
              {step.label}
            </StepLabel>
            <StepContent>
              <Typography>{step.description}</Typography>
            </StepContent>
          </Step>
        ))}
      </Stepper>
      <Box mt={3}>
        <Typography variant='h4' style={{ fontSize: 14 }}>
          I have read and agree with the{' '}
          <a
            style={{ color: '#002984' }}
            href={'/client-static/tngCampaign/TermsCondition.pdf'}
            target='_blank'
            rel='noopener noreferrer'
          >
            Terms & Conditions
          </a>{' '}
          and{' '}
          <a
            style={{ color: '#002984' }}
            href={'/client-static/tngCampaign/PersonalDataPrivacyNotice.pdf'}
            target='_blank'
            rel='noopener noreferrer'
          >
            Privacy Policy.
          </a>
        </Typography>
      </Box>
    </Box>
  )
}
